<template>
  <div class="w-100">
    <check-box-manager class="my-2 filter-category-1-check-box-manager" :CheckBoxItems="categories"
                       label="انتخاب دسته بندی"
                       :selectedCheckBoxes="selectedCategory" :validation="$v.selectedCategory"/>
  </div>
</template>

<script>
import CheckBoxManager from "../../../Content/FormItems/CheckBoxManager.vue";

export default {
  name: "FilterCategory1",
  components: {CheckBoxManager},
  data() {
    return {
      categories: [],
      selectedCategory: []
    }
  },
  validations: {
    selectedCategory: {},
  },
  async mounted() {
    this.categories = await this.$store.dispatch('Category/getCategoriesWithoutState')
    this.categories = this.categories.data.data
  },
  watch: {
    selectedCategory: {
      handler(oldValue, newValue) {
        this.$emit('updateFilter', {category: this.selectedCategory})
      }
    }
  },
}
</script>

<style scoped>
.filter-category-1-check-box-manager {
  width: 100% !important;
  max-width: 100% !important;
}
</style>